import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import uuid from "react-uuid";
import { loadPaymentWidget } from "@tosspayments/payment-widget-sdk";

import { BsChevronLeft } from "react-icons/bs";

import { calcPrice } from "../shopping/common/function/shopping";
import { useDisableScroll } from "../../hooks/useDisableScroll";
import { Container, OrderContainer } from "./component/styled/setting";

const MAX_RETRY = 10;
const RETRY_DELAY = 500;
// const clientKey = "test_gck_6bJXmgo28eDjx71vzNp6rLAnGKWx";
const clientKey = "live_gck_5OWRapdA8dGRyYlOWMdbro1zEqZK";

const MenuBoardOrder = () => {
  const navigate = useNavigate();
  const { cmpnyNo } = useParams();
  const location = useLocation();

  const [paymentType, setPaymentType] = useState("CASH");
  const [isTossPay, setIsTossPay] = useState(true);

  useDisableScroll();

  const formatNumber = (num) => (Number(num) || 0).toLocaleString("ko-KR");
  const items = Array.isArray(location.state?.items) ? location.state.items : [];

  const widgetRef = useRef(null);
  const widgetContainerRef = useRef(null);
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  const totalPrice = useMemo(() => {
    return items.reduce((sum, item) => sum + calcPrice(item), 0);
  }, [items]);

  useEffect(() => {
    if (!items.length || !cmpnyNo) {
      navigate(`/menu-board/${cmpnyNo}/cart`);
    }
  }, [items, cmpnyNo]);

  useEffect(() => {
    if (!isTossPay) return;
    if (!widgetContainerRef.current || !items.length) return;
    const timeout = setTimeout(() => {
      requestAnimationFrame(() => {
        initPaymentWidget();
      });
    }, 300);
    return () => clearTimeout(timeout);
  }, [items, isTossPay]);

  const initPaymentWidget = async (retry = 0) => {
    const amount = Number(totalPrice || 0);
    if (!isTossPay) return;
    if (amount <= 0) return;
    try {
      const widget = await loadPaymentWidget(clientKey, uuid());
      await widget.renderPaymentMethods("#payment-widget", {
        value: amount,
        ...getOrderDetails(),
      });
      widgetRef.current = widget;
      setWidgetLoaded(true);
    } catch (err) {
      if (retry < MAX_RETRY) {
        setTimeout(() => initPaymentWidget(retry + 1), RETRY_DELAY);
      }
    }
  };

  const getOrderDetails = () => ({
    orderId: uuid(),
    orderName: "매장 주문",
    customerName: "비회원",
    customerEmail: "noemail@example.com",
  });

  const handlePay = async () => {
    if (!items.length) return;
    if (!totalPrice || isNaN(totalPrice)) return;
    if (!widgetRef.current) return;
    try {
      localStorage.setItem(`mbOrderItems:${cmpnyNo}`, JSON.stringify(items));
      await widgetRef.current.requestPayment({
        ...getOrderDetails(),
        // successUrl: `http://localhost:3001/menu-board/${cmpnyNo}/order/success`,
        // failUrl: `http://localhost:3001/menu-board/${cmpnyNo}/order/fail`,
        successUrl: `https://1472.ai/menu-board/${cmpnyNo}/order/success`,
        failUrl: `https://1472.ai/menu-board/${cmpnyNo}/order/fail`,
      });
    } catch (err) {
      alert(err.message);
    }
  };

  const toggleTossPay = (isToss, isType = "") => {
    setIsTossPay(isToss);
    setPaymentType(isType);
    if (!isToss) {
      setWidgetLoaded(false);
      widgetRef.current = null;
    }
  };

  const checkoutPay = () => {
    if (!items.length) return;
    if (!totalPrice || isNaN(totalPrice)) return;
    localStorage.setItem(`mbOrderItems:${cmpnyNo}`, JSON.stringify(items));
    navigate(`/menu-board/${cmpnyNo}/order/success?paymentType=${paymentType}`);
  };

  return (
    <Container>
      <OrderContainer>
        <div className="hd">
          <button onClick={() => navigate(`/menu-board/${cmpnyNo}/cart`)}>
            <BsChevronLeft />
          </button>
          <p>결제</p>
        </div>
        <div className="content">
          <div>
            <div className="payment-method">
              <button
                onClick={() => toggleTossPay(true)}
                className={`simple ${isTossPay ? "active" : "inactive"}`}>
                간편결제
              </button>
              <button
                onClick={() => toggleTossPay(false)}
                className={`cash ${!isTossPay ? "active" : "inactive"}`}>
                현장결제
              </button>
            </div>
            {isTossPay && <div id="payment-widget" ref={widgetContainerRef}></div>}
            {!isTossPay && (
              <div className="payment-store">
                <button
                  onClick={() => toggleTossPay(false, "CARD")}
                  className={`card ${paymentType === "CARD" ? "active" : "inactive"}`}>
                  카드
                </button>
                <button
                  onClick={() => toggleTossPay(false, "CASH")}
                  className={`cash ${paymentType === "CASH" ? "active" : "inactive"}`}>
                  현금
                </button>
              </div>
            )}
          </div>
          <button
            className="submit"
            disabled={isTossPay && !widgetLoaded}
            onClick={() => (isTossPay ? handlePay() : checkoutPay())}>
            {formatNumber(totalPrice)}원 {isTossPay ? "결제" : "주문"}
          </button>
        </div>
      </OrderContainer>
    </Container>
  );
};

export default MenuBoardOrder;
